// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/reset.scss'
import '@/assets/css/personal.scss'
import '@/assets/css/mixin.scss'
import api from '@/api/index'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$ELEMENT = {size: 'medium'}
Vue.prototype.$api = api
let webUrl = window.location.origin
Vue.prototype.$noPic = webUrl + '/static/personal/no_pic.jpg'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js